<ul class="grid-view">
  <li id="outage-btn"  [ngClass]="outage ? 'active' : 'notactive'" ><a (click)="outagecolor()" routerLink="/iday-profile" id="outage-link">Profile Update</a></li>
  <li id="release-btn"  [ngClass]="release ? 'active' : 'notactive'" ><a (click)="releasecolor()" routerLink="/logo" id="release-link">Logo Update</a></li>
  <li class="logout-btn" id="logout"><a (click)="logout()" >Logout</a></li>
</ul>
